export default __webpack_public_path__ + "static/media/opensea.a640df12.svg";